import { render, staticRenderFns } from "./Tray.vue?vue&type=template&id=512f01ba&"
import script from "./Tray.vue?vue&type=script&lang=ts&"
export * from "./Tray.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports